import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import BorrowAvanceVoucherListWidget from '../../../widgets/projectBasedItemsWidget/BorrowAvanceVoucherListWidget'
import { getBorrowAdvancePage } from '../../../redux/actions/paymentRecordAdvance'

export default function BorrowAvanceVoucherList() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const history = useHistory()

  useEffect(() => {
    handleGetSchema()

    if (!periodNumber || !projectCode) {
      history.push({
        pathname: pathname.incomeAndExpense.ProjectBasedItems,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getBorrowAdvancePage(projectCode, periodNumber)

      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isIncomeExpense>
      <ContentHeader
        header={schema?.header || 'รายละเอียดการบันทึกยืม-คืนเงินทดรองจ่าย'}
        subHeader={''}
        isNotCallApi
        isShowGoButton
      />

      <BorrowAvanceVoucherListWidget
        schema={schema}
        periodNumber={periodNumber}
        projectCode={projectCode}
      />

      <br />
    </SidebarProposal>
  )
}
